import React from 'react';

const C = () => <>&#8599;</>;

export default C;
